import {
    kuwaitGovernatesAr,
    kuwaitGovernatesEn,
    bahrainGovernoratesAr,
    bahrainGovernoratesEn,
    saudiArabiaGovernoratesAr,
    saudiArabiaGovernoratesEn,
} from './helper';

export const KUWAIT_COUNTRY_ID = 112;

// governorate name -> list of area names, for the given country and language
export const getGovernorates = (countryId, isArabic) => {
    switch (+countryId) {
        case KUWAIT_COUNTRY_ID:
            return isArabic ? kuwaitGovernatesAr : kuwaitGovernatesEn;
        case 17:
            return isArabic ? bahrainGovernoratesAr : bahrainGovernoratesEn;
        case 188:
            return isArabic ? saudiArabiaGovernoratesAr : saudiArabiaGovernoratesEn;
        default:
            return {};
    }
};

const isListIndex = (value) => /^\d+$/.test(String(value ?? '').trim());

// addresses saved by older mobile app versions have the area's list index stored in `city`
export const hasLegacyNumericArea = (address) => isListIndex(address?.city);

// Maps a legacy address's stored indexes back to { state, city } names, or null when it can't be done.
// Only non-Kuwait addresses stored their governorate index in `state`; Kuwait ones never stored it,
// so their area index alone is ambiguous and the user has to pick it again.
export const resolveLegacyArea = (address, isArabic) => {
    if (!hasLegacyNumericArea(address) || !isListIndex(address?.state)) {
        return null;
    }
    const governorates = getGovernorates(address.country_id, isArabic);
    const state = Object.keys(governorates)[+address.state];
    const city = governorates[state]?.[+address.city];
    return state && city ? { state, city } : null;
};

// the address fields accepted by the add/edit endpoints
export const toAddressPayload = (address, overrides = {}) => ({
    category: address.category,
    country_id: address.country_id,
    address: address.address,
    house: address.house,
    block: address.block,
    street: address.street,
    apartment: address.apartment,
    directions: address.directions,
    city: address.city,
    state: address.state,
    pin_code: address.pin_code,
    ...overrides,
});
